import { isFeatureEnabled } from '@/vuex/modules/featureToggles.module'

const _state = {}
const _getters = {
  isAhaSlidesGPTEnabled: (_, __, ___, rootGetters) => {
    return isFeatureEnabled(rootGetters, 'release-ai-aha-gpt')
  },
}
const mutations = {}
const actions = {}

export default {
  namespaced: true,
  state: _state,
  getters: _getters,
  actions,
  mutations,
}
